export default "__VITE_ASSET__D93AksIt__"